import { Navigate } from 'react-router-dom'
import DashboardLayout from './components/DashboardLayout'
import MainLayout from './components/MainLayout'
import HomeFittings from './pages/HomeFittings'
import HomeHoses from './pages/HomeHoses'
import Account from './pages/Account'
import Dashboard from './pages/Dashboard'
import Login from './pages/Login'
import EmailConfirmation from './pages/EmailConfirmation'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import ResetPasswordUser from './pages/ResetPasswordUser'
import NotFound from './pages/NotFound'
import HoseList from './pages/HoseList'
import AdminList from './pages/AdminList'
import FittingList from './pages/FittingList'
import HomePage from './pages/HomePage'
import Product from './pages/Product'
import Register from './pages/Register'
import Settings from './pages/Settings'
import Cart from './pages/Cart'
import NewCart from './pages/NewCart'
import Orders from './pages/OrderList'
import Shopping from './pages/ShoppingList'
import OrderDetail from './pages/OrderDetail'
import Order from './pages/Order'
import CustomerList from './pages/CustomerList'
import CustomerProfile from './components/customer/CustomerProfile'
import AdminProfile from './components/admin/AdminProfile'
import AddCustomer from './pages/AddCustomer'
import AddAdmin from './pages/AddAdmin'

const routes = [
   {
      path: 'app',
      element: <DashboardLayout />,
      children: [
         { path: 'account', element: <Account /> },
         { path: 'hoses', element: <HoseList /> },
         { path: 'admin', element: <AdminList /> },
         { path: 'customers', element: <CustomerList /> },
         { path: 'customers/profile/:id', element: <CustomerProfile /> },
         { path: 'admin/profile/:id', element: <AdminProfile /> },
         { path: 'dashboard', element: <Dashboard /> },
         { path: 'fittings', element: <FittingList /> },
         { path: 'product/:product', element: <Product /> },
         { path: 'cart', element: <Cart /> },
         { path: 'orders', element: <Orders /> },
         { path: 'shopping', element: <Shopping /> },
         { path: 'order-detail/:order', element: <OrderDetail /> },
         { path: 'settings', element: <Settings /> },
         { path: 'add-customers', element: <AddCustomer /> },
         { path: 'add-admin', element: <AddAdmin /> },
         { path: '*', element: <Navigate to='/404' /> }
      ]
   },
   {
      path: '/',
      element: <MainLayout />,
      children: [
         { path: 'order/:order', element: <Order /> },
         { path: 'confirmation/:token0/:token1/:token2', element: <EmailConfirmation /> },
         { path: 'reset-password/:token0/:token1/:token2', element: <ResetPassword /> },
         { path: 'reset-password-user/:token0/:token1/:token2', element: <ResetPasswordUser /> },
         { path: 'reset-password', element: <ForgotPassword /> },
         { path: 'login', element: <Login /> },
         { path: 'register', element: <Register /> },
         { path: '404', element: <NotFound /> },
         { path: '/', element: <HomePage /> },
         { path: '/hoses', element: <HomeHoses /> },
         { path: '/fittings', element: <HomeFittings /> },
         { path: '/product/:product', element: <Product /> },
         { path: '/view-cart', element: <NewCart /> },
         { path: '/application', element: <Navigate to='/app/dashboard' /> },
         { path: '*', element: <Navigate to='/404' /> }
      ]
   }
]

export default routes
